export const MAX_UPLOAD_SIZE = 8 * 1024 * 1024 * 1024 // 8GB

export const MAX_UPLOAD_FILES_WARNING_LIMIT = 100
export const MAX_UPLOAD_FILES_ERROR_LIMIT = 200
